// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoESpot_container__Z_aJE","video":"VideoESpot_video__5jcKb"};